import { x as d, s as v } from "../../../lit-element-6iugfgmM.js";
import { e as p } from "../../../custom-element-wk-AooBb.js";
import { n as m } from "../../../property-BWlAHqg_.js";
import "../../../query-assigned-elements-B8U94KLQ.js";
import "../../../sp-button-DfcLwvTE.js";
import "../../../sp-dialog-BZDyJQAd.js";
import "../../../sp-dialog-base-BJGUzA_h.js";
import "../../../sp-checkbox-D1L__GdV.js";
import h from "../../../events/VariationFavoriteEvent.js";
import c from "../../../events/UserPrefsEvent.js";
import { Localize as f } from "../../../lib/I18N.js";
const g = { "remove-from-favorites-dialog.body": "Remove all font selections from your favorites.", "remove-from-favorites-dialog.cancel-button": "Cancel", "remove-from-favorites-dialog.dont-show-again": "Don't show again", "remove-from-favorites-dialog.heading": "Remove favorites", "remove-from-favorites-dialog.remove-button": "Remove" };
var b = Object.defineProperty, u = Object.getOwnPropertyDescriptor, r = (i, e, s, a) => {
  for (var n, o = a > 1 ? void 0 : a ? u(e, s) : e, l = i.length - 1; l >= 0; l--) (n = i[l]) && (o = (a ? n(e, s, o) : n(o)) || o);
  return a && o && b(e, s, o), o;
};
let t = class extends f(v, g) {
  constructor() {
    super(...arguments), this.httpDisabled = !1, this.variationIds = [], this.open = !1;
  }
  render() {
    return d`<sp-dialog-base .open="${this.open}" @close="${this._handleClose}" underlay dismissable><sp-dialog size="m" variant="destructive"><h2 slot="heading">${this.t("remove-from-favorites-dialog.heading")}</h2><p>${this.t("remove-from-favorites-dialog.body")}</p><sp-checkbox id="dont_show_again_checkbox" slot="footer" @click="${this._handleDontShowAgainClick}">${this.t("remove-from-favorites-dialog.dont-show-again")}</sp-checkbox><sp-button id="cancel_button" variant="secondary" treatment="outline" slot="button" @click="${this._handleClose}">${this.t("remove-from-favorites-dialog.cancel-button")}</sp-button><sp-button id="remove_button" variant="negative" slot="button" @click="${this._handleRemoveButtonClick}">${this.t("remove-from-favorites-dialog.remove-button")}</sp-button></sp-dialog></sp-dialog-base>`;
  }
  _handleClose() {
    this.open = !1, this.dispatchEvent(new Event("close", { bubbles: !0, composed: !0 }));
  }
  _handleDontShowAgainClick(i) {
    const e = i.target;
    this.dispatchEvent(new c({ hideRemoveFromFavoritesDialog: !e.checked }));
  }
  _handleRemoveButtonClick() {
    this.open = !1, this.dispatchEvent(new h({ removeVariationIds: this.variationIds }));
  }
};
r([m({ type: Boolean })], t.prototype, "httpDisabled", 2), r([m({ type: Array })], t.prototype, "variationIds", 2), r([m({ type: Boolean })], t.prototype, "open", 2), t = r([p("af-remove-from-favorites-dialog")], t);
const I = t;
export {
  I as default
};
//# sourceMappingURL=RemoveFromFavoritesDialog.js.map
